export default __webpack_public_path__ + "static/media/pic5.37470ec3.jpg";